import { STAT_LEVEL_CLASSES } from "./constant";

function isObject(value) {
  return typeof value === "object" && !Array.isArray(value) && value !== null;
}

function getLevelClass(level, type = STAT_LEVEL_CLASSES.TIME) {
  const color = getLevelColor(Number(level));
  return color ? `${type}-${color}` : "";
}

function getLevelColor(level) {
  switch (level) {
    case 1:
      return "success";
    case 2:
      return "warning";
    case 3:
      return "danger";
    default:
      return "";
  }
}

export default {
  isObject,
  getLevelClass,
};
